import React from 'react';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import { Box } from '@mui/material';
const ExclamationIcon = (props: any) => {
	return (
		<Box sx={{ position: 'relative', height: '40px', width: '40px' }}>
			<PriorityHighRoundedIcon
				{...props}
				sx={{ position: 'absolute', top: '5px', left: '8px' }}
			/>
		</Box>
	);
};
const DoubleExclamationIcon = (props: any) => {
	return (
		<Box sx={{ position: 'relative', height: '40px', width: '40px' }}>
			<PriorityHighRoundedIcon
				{...props}
				sx={{ position: 'absolute', left: '6px', top: '5px' }}
			/>
			<PriorityHighRoundedIcon
				{...props}
				sx={{ position: 'absolute', left: '11px', top: '5px' }}
			/>
		</Box>
	);
};

const TripleExclamationIcon = (props: any) => {
	return (
		<Box sx={{ position: 'relative', height: '40px', width: '40px' }}>
			<PriorityHighRoundedIcon
				{...props}
				sx={{ position: 'absolute', left: '2px', top: '5px' }}
			/>
			<PriorityHighRoundedIcon
				{...props}
				sx={{ position: 'absolute', left: '7px', top: '5px' }}
			/>
			<PriorityHighRoundedIcon
				{...props}
				sx={{ position: 'absolute', left: '12px', top: '5px' }}
			/>
		</Box>
	);
};

export { ExclamationIcon, DoubleExclamationIcon, TripleExclamationIcon };
